import { render, staticRenderFns } from "./editable-description.vue?vue&type=template&id=7c5fc290"
import script from "./editable-description.vue?vue&type=script&lang=js"
export * from "./editable-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports